import isValidNumber from './isValidNumber';
import { getDecimalSeparator } from './removeNumberSeparators';
export default function isValidInteger(value) {
  if (isValidNumber(value)) {
    var decimalSeparator = getDecimalSeparator();
    return value.toString().indexOf(decimalSeparator) === -1;
  }
  return false;
}